import HeadData from 'components/Common/HeadData'
import React from 'react'

function CruiseDestinationsHeadData(props: { destination: string }) {
  const { destination } = props
  const currentYear = new Date().getFullYear()
  const title = `Cruises to ${destination} | Best Deals ${currentYear} - ${currentYear + 1}`
  const description = `Embark on a cruise to ${destination} with Luxury Escapes. Browse our wide variety of exclusive deals and curated extras to make your cruise unforgettable.`

  return <HeadData title={title} description={description} />
}

export default CruiseDestinationsHeadData
